import React, { Component } from 'react';
import { Outlet } from 'react-router-dom';

class NonAuthLayout extends Component {
  render() {
    return (
      <React.Fragment>
        <Outlet />
      </React.Fragment>
    );
  }
}

export default NonAuthLayout;
